import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const CourseCard = ({ course }) => {
  return (
    <div className="course-card">
      <h3>{course.title}</h3>
      {/* <div className="price">
        {course.price } <span>{course.originalPrice}</span>
      </div> */}
      <ul>
        {course.features.map((feature, index) => (
          <li key={index}>
            <FontAwesomeIcon icon={faCheck} className="feature-icon" /> {feature}
          </li>
        ))}
      </ul>
      {/* <Link to={`/courses/${course.id}`} className="cta-button">
        Enroll Now
      </Link> */}
<Link to={`/${course.id}`} className="cta-button">
        More Info
      </Link>
    </div>
  );
};

export default CourseCard;